import { Box, Button, CircularProgress } from "@mui/material";

export const LoadMoreButton = ({
  loadMoreMessages,
  loading,
}: {
  loadMoreMessages: () => void;
  loading: boolean;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: 3,
        mb: 1.5,
      }}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={loadMoreMessages}
        disabled={loading}
        data-cypress="load-more-button"
        sx={{
          minWidth: { xs: 160, sm: 200 },
          py: { xs: 1, sm: 1.25 },
          px: { xs: 3, sm: 4 },
          borderRadius: 1.5,
          fontWeight: 700,
          textTransform: "none",
          fontSize: { xs: "0.875rem", sm: "0.95rem" },
        }}
      >
        {loading ? (
          <>
            <CircularProgress size={18} sx={{ mr: 1, color: "white" }} />
            Loading...
          </>
        ) : (
          "Load More"
        )}
      </Button>
    </Box>
  );
};

